<div *ngIf='data' class='EmailPosition'>
  <p *ngIf='data.last_email_at; else noEmail'>Last
    email: {{ data.last_email_at | timezone: 'MM/DD/YYYY [at] HH:mm' : userTimezone }}</p>
  <ng-template #noEmail>
    <p>Last Email: No Email Sent</p>
  </ng-template>
  <ng-template #noNext>
    <ng-container *ngIf='contactStatus === "Active";'>
      <p>Contact is scheduled for mailing at next service date</p>
    </ng-container>
  </ng-template>
</div>
